import styled, { css } from 'styled-components';

export const Col = styled.div`
  display: flex;
  flex-flow: wrap column;
`;

Col.displayName = 'SettingsTeacherProfileCol';

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

Row.displayName = 'SettingsTeacherProfileRow';

export const StylesImageModalResultsUpdateTeacher = css`
  margin: 30px auto;
  width: 150px;
  height: auto;
`;
